/**
 * Utility to clear old API-related cached data from localStorage
 */

export const clearOldApiCache = () => {
  try {
    // Clear any localStorage items that might contain old API URLs
    const keysToCheck = [
      'api_cache',
      'lead_cache', 
      'apiClient_cache',
      'api_base_url'
    ];
    
    let clearedItems = 0;
    
    keysToCheck.forEach(key => {
      const value = localStorage.getItem(key);
      if (value && (value.includes('ai.lnk2.im') || value.includes(':9001'))) {
        localStorage.removeItem(key);
        clearedItems++;
        console.log(`🗑️ Cleared old API cache: ${key}`);
      }
    });
    
    if (clearedItems > 0) {
      console.log(`✅ Cleared ${clearedItems} cached items with old API URLs`);
    }
  } catch (error) {
    console.warn('Failed to clear API cache:', error);
  }
};